<mat-card>
    <mat-card-header>
        <mat-card-title>{{ activity.type }}</mat-card-title>
        <mat-card-subtitle>{{ activity.value }}</mat-card-subtitle>
    </mat-card-header>
</mat-card>
